<template>
  <div>
    <template v-if="edit">
      <form
        method="post"
        action="javascript:void(0)"
        @submit="saveForm()"
        class="flex"
      >
        <input type="text" class="uk-input" v-model="form.fieldValue" />
        <button
          type="submit"
          @click="saveForm()"
          class="uk-button sm-btn flex items-center justify-start uk-button-secondary uk-button-small"
        >
          <span>
            <vk-icon icon="check" size="0.5"></vk-icon>
          </span>
        </button>
      </form>
    </template>
    <template v-else>
      <div class=" flex items-center justify-start">
        <span>{{ form.fieldValue }}</span>
        <vk-icon @click="edit = true" icon="pencil"></vk-icon>
      </div>
    </template>
  </div>
</template>

<script>
import HttpService from "../../services/http";
export default {
  name: "inline-edit",
  props: {
    fieldValue: String,
    fieldName: String,
    keyName: String,
    keyValue: Number | String,
    table: String,
    type: String,
  },
  data() {
    return {
      form: {},
      edit: false,
    };
  },
  created() {
    this.form.keyValue = this.keyValue;
    this.form.keyName = this.keyName;
    this.form.fieldValue = this.fieldValue;
    this.form.fieldName = this.fieldName;
    this.form.type = this.type;
    this.form.table = this.table;
  },
  methods: {
    saveForm() {
      HttpService.inlineSave(this.form).then((resp) => {
        if (resp.data.success) {
          this.edit = false;
          this.$emit("after", "success");
        }
      });
    },
  },
};
</script>

<style>
.flex {
  display: flex;
}

.flex .sm-btn {
  font-size: 10px;
  padding: 0px 10px;
  margin: 0px;
}
</style>
